import activateForm from './forms/activateForm';
import resetForm from './forms/resetForm';

const lightboxes = {};
let register;
let show;
let hide;

const initialize = () => {
  if (!register) {
    // Create reusable elements
    const $obfuscator = $('<div class="mdl-layout__obfuscator mdl-layout__obfuscator--lightbox"></div>').appendTo('.mdl-layout');
    const $lightboxWrapper = $('<div class="lightbox__wrapper"></div>').insertAfter($obfuscator);
    const $lightbox = $('<div class="lightbox"></div>').appendTo($lightboxWrapper);
    const $lightboxCloseButton = $('<div class="lightbox__close-button">Close</div>').appendTo($lightbox);
    const $lightboxTitle = $('<h3 class="lightbox__title">Override this</h3>').appendTo($lightbox);
    const $lightboxContent = $('<div class="lightbox__content"></div>').appendTo($lightbox);

    const setKind = (kind) => {
      const kindClass = (typeof kind !== 'undefined') ? `lightbox--${kind}` : '';
      $lightbox.attr('class', `lightbox ${kindClass}`);
    };

    register = (lightbox) => {
      const delay = lightbox.getAttribute('delay') * 1000;
      lightboxes[lightbox.getAttribute('id')] = $(lightbox).remove();
      if (delay) {
        setTimeout(() => {
          show(lightbox.getAttribute('title'), lightbox.getAttribute('id'));
        }, delay);
      }
    };

    show = (title, lightboxId, data) => {
     
      let $content;
      if (typeof lightboxId !== 'undefined') {
        $content = lightboxes[lightboxId].clone(true, true);
        $content.appendTo($lightboxContent.empty());
        activateForm($('.form', $content), data);

        if(data != null && data.url != null && $content[0].id == "lightboxVideo")
        {
            $content[0].children[0].src = data.url
        }
      }

      if (title) {
        $lightboxTitle.html(title);
        $lightboxTitle.css('display', 'block');
      }
      else if ($content.attr('default-title')) {
          $lightboxTitle.html($content.attr('default-title'));
          $lightboxTitle.css('display', 'block');
      }
      else {
        $lightboxTitle.css('display', 'none');
      }
        setKind(lightboxId);
        if (lightboxId === 'updates') {
            InitiateSignupFormValidation();
        }
      $obfuscator.addClass('is-visible');
      return $content;
    };

    hide = () => {
      $obfuscator.removeClass('is-visible');
      resetForm($('form', $lightbox));
      setKind();
    };

    // Add default click handlers
    $lightboxCloseButton.on('click', hide);
    $lightboxWrapper.on('click', hide);
    $lightbox.on('click', (e) => {
      e.stopPropagation();
    });

    // Automatically register Lightboxes
    Array.from(document.getElementsByTagName('Lightbox')).forEach(register);
  }

  return { show, hide, register };
};

export default initialize;
export const showLightbox = (title, lightboxId, data) => {
  initialize().show(title, lightboxId, data);
};
export const hideLightbox = () => {
  initialize().hide();
};
